module.exports = __webpack_public_path__ + "static/media/CompanySecretarialServices.70b2fe29.jpg";